import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../../store';
import { AllFloors, allFloorsType } from './types';
import merge from 'deepmerge'
import { lockUnLockSingle, lockUnlockaAll } from './locksApi';

export interface LocksState {
    locks: allFloorsType[],
    status?: string,
    loading?: boolean,
    doorLoading?: boolean,
    selectedGate?: number;
}

const initialState: LocksState = {
    locks: AllFloors,
    status: 'idle',
    loading: false,
    doorLoading: false,
    selectedGate: 0

};

export const handleLockUnlockAsync = createAsyncThunk(
    'locks/lockUnlock',
    async (lockAll: boolean, { getState }) => {
        const { locks } = getState() as { locks: LocksState };

        const response = await lockUnlockaAll(locks.locks, lockAll);
        return response.data;
    }
);
export const lockDoorAsync = createAsyncThunk(
    'locks/lockDoor',
    async (doorId: number, { getState }) => {
        const { locks } = getState() as { locks: LocksState };

        const response = await lockUnLockSingle(locks.locks, doorId);
        return response.data;
    }
);

export const LocksSlice = createSlice({
    name: 'locks',
    initialState,
    reducers: {
        lockUnLockDoor: (state, action: PayloadAction<{ doorId: number, isLocked: boolean }>) => {
            state.doorLoading = true

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(handleLockUnlockAsync.pending, (state) => {
                state.loading = true
                state.status = 'loading';
            })
            .addCase(handleLockUnlockAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false
                state.locks = action.payload
            })
            .addCase(handleLockUnlockAsync.rejected, (state) => {
                state.status = 'failed';
            }).addCase(lockDoorAsync.pending, (state, action) => {
                state.doorLoading = true
                state.selectedGate = action?.meta?.arg
            }).addCase(lockDoorAsync.fulfilled, (state, action) => {
                state.doorLoading = false
                state.locks = action.payload
            })
    },

});

export const { lockUnLockDoor } = LocksSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectLock = (state: RootState) => state.locks;
export const selectGates = (state: RootState) => state.locks.locks;


export default LocksSlice.reducer;
